import { Component } from '@angular/core';
import { AppComponent } from '../../app.component';
import { EnvService } from '../../core/services/env.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  template: `
    <div class="layout-footer">
      <div class="footer-logo-container">
        <img
          id="footer-logo"
          [src]="'assets/layout/images/logo-' + (app.colorScheme === 'light' ? 'dark' : 'light') + '.png'"
          alt="atlantis-layout"
        />
        <span class="app-name">{{ 'title.page' | appTranslate: 'initial_page' }} </span>
      </div>
      <span class="copyright">&#169; {{ copyright }} - {{ version }}</span>
    </div>
  `
})
export class AppFooterComponent {
  constructor(public app: AppComponent, public envService: EnvService, protected translateService: TranslateService) {}

  get copyright(): string {
    return this.translateService.instant('initial_page.title.copyright'.toUpperCase(), {
      year: new Date().getFullYear()
    });
  }

  get version(): string {
    return this.translateService.instant('application.version'.toUpperCase(), {
      version: this.envService.environment.version
    });
  }
}
